var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOkta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6297,
    cy: 23.5432,
    r: 23.5432,
    fill: "url(#paint0_radial_10_1353)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_1353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6296 7.49097C14.7578 7.49097 7.57739 14.6714 7.57739 23.5432C7.57739 32.415 14.7578 39.5954 23.6296 39.5954C32.5014 39.5954 39.6818 32.415 39.6818 23.5432C39.6818 14.6714 32.5014 7.49097 23.6296 7.49097ZM23.6296 31.5852C19.1937 31.5852 15.5875 27.9791 15.5875 23.5432C15.5875 19.1072 19.1937 15.5011 23.6296 15.5011C28.0655 15.5011 31.6717 19.1072 31.6717 23.5432C31.6717 27.9791 28.0655 31.5852 23.6296 31.5852Z",
    fill: "#007DC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10_1353",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0685 10.969) rotate(52.6646) scale(92.1962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#595959"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_1353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.1044,
    height: 32.1044,
    fill: "white",
    transform: "translate(7.57739 7.49097)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkta);
export default __webpack_public_path__ + "static/media/okta.c400cbddef9aa740a66de9eb58188619.svg";
export { ForwardRef as ReactComponent };